import { CodeBlock as BaseCodeBlock } from '@docpocalypse/code-live';
import React from 'react';
import theme from '../syntax-theme';

var styles = require('./CodeBlock-styles.module.css');

function CodeBlock(_ref) {
  var className = _ref.className,
      title = _ref.title,
      language = _ref.language,
      lineNumbers = _ref.lineNumbers,
      _ref$code = _ref.code,
      code = _ref$code === void 0 ? '' : _ref$code;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.CodeBlock
  }, title && /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, title), /*#__PURE__*/React.createElement(BaseCodeBlock, {
    className: className,
    theme: theme,
    code: code,
    lineNumbers: lineNumbers,
    language: language
  }));
}

export default CodeBlock;